const { useEffect } = wp.element;

const Style = ({ attributes, setAttributes }) => {
  const { uniqueId, primaryColor, hoverColor, bgColor, radius, width, align, CSS } = attributes;

  useEffect(() => {
    const CSS = `#${uniqueId}{justify-content:${align};}#${uniqueId} .plyr, #${uniqueId} .flat-black-player-container{ width: ${width};}#${uniqueId} .plyr__controls {background: ${bgColor};border-radius:${radius}}#${uniqueId} .skin_default .plyr__control,#${uniqueId} .plyr__time{color: ${primaryColor}}#${uniqueId}{--theme-skin-wave-color: ${primaryColor};} #${uniqueId}.skin_default .plyr__control:hover {background: ${hoverColor}}#${uniqueId} .plyr__controls__item input {color: ${hoverColor}}`;

    setAttributes({ CSS });
  }, [width, bgColor, radius, uniqueId, hoverColor, primaryColor, align]);

  return <style>{CSS}</style>;
};

export default Style;
